import { mapToContentItem } from "../../Discover/services/searchResultsMapperService";
import { type ContentItem, type SearchResult } from "../../AssetResults/types";

export function mapToGroupContentItems(searchResults: SearchResult[]): ContentItem[] {
  return searchResults.map(mapToGroupContentItem);
}

export function mapToGroupContentItem(searchResult: SearchResult): ContentItem {
  return {
    ...mapToContentItem(searchResult),
    completionStatus: undefined,
  } as ContentItem;
}
